import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-organisation-settings-button',
  standalone: true,
  imports: [MatTooltipModule, MatIconModule, CommonModule],
  templateUrl: './organisation-settings-button.component.html',
  styleUrl: './organisation-settings-button.component.scss'
})
export class OrganisationSettingsButtonComponent {

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ){}
  
  
  goToOrganisationSettings(){
    this.router.navigate(['settings', 'organisation-settings', 'details'])
  }
}
